"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesktopPartsOverlay = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_1 = require("@completeanatomy/bridge");
const models_1 = require("@completeanatomy/models");
const ui_1 = require("@completeanatomy/ui");
const useOverlayComponents_1 = require("../../hooks/useOverlayComponents");
const focus_trap_react_1 = require("focus-trap-react");
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importStar(require("styled-components"));
/* eslint-disable max-lines-per-function */
function DesktopPartsOverlay({ name, parts, currentTab, isFullScreen, onCloseFullScreen, onToggleFullScreen, }) {
    const selectedPart = parts.find(spot => spot.isSelected);
    const bridge = (0, bridge_1.useBridge)();
    const theme = (0, styled_components_1.useTheme)();
    const isLoading = (0, models_1.useIsModelLoading)();
    const progress = (0, models_1.useDownloadingProgress)();
    const ref = (0, react_1.useRef)(null);
    const modelContainer = (0, react_1.useRef)(null);
    const closeRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (closeRef.current) {
            closeRef.current.focus();
        }
    }, []);
    (0, react_1.useEffect)(() => {
        var _a;
        const model = document.getElementById('model-container');
        if (!model)
            return;
        const originalParent = model.parentElement;
        (_a = modelContainer.current) === null || _a === void 0 ? void 0 : _a.appendChild(model);
        return () => {
            if (originalParent) {
                originalParent.appendChild(model);
            }
        };
    }, []);
    const onSelectPart = (spot) => {
        bridge === null || bridge === void 0 ? void 0 : bridge.selectInfoBoxListItem({
            type: currentTab,
            index: spot.index,
            identifier: spot === null || spot === void 0 ? void 0 : spot.identifier,
        });
    };
    const fullScreenButtons = isFullScreen && ((0, jsx_runtime_1.jsx)(ui_1.CloseForGrasshopper, { onClick: onCloseFullScreen, "data-e2e": 'DesktopPartsOverlay_CloseForGrasshopper' }));
    const subtitle = (selectedPart === null || selectedPart === void 0 ? void 0 : selectedPart.subtitle) && ((0, jsx_runtime_1.jsxs)(Subtitle, { "data-e2e": 'DesktopPartsOverlay_Subtitle', children: ["(", selectedPart.subtitle, ")"] }));
    const { SidebarComponent, MotionControl, isSidebarComponent, title } = (0, useOverlayComponents_1.useOverlayComponents)({
        tabType: currentTab,
        props: {
            sidebar: {
                parts,
                name,
                selectedPart,
                tabName: name || '',
                onClick: onSelectPart,
            },
        },
        isFullScreen: !!isFullScreen,
    });
    return ((0, jsx_runtime_1.jsx)(focus_trap_react_1.FocusTrap, { focusTrapOptions: { allowOutsideClick: true }, "data-e2e": 'DesktopPartsOverlay_FocusTrap', children: (0, jsx_runtime_1.jsxs)(Container, { role: "dialog", ref: ref, "data-e2e": 'DesktopPartsOverlay_Container', children: [SidebarComponent, (0, jsx_runtime_1.jsxs)(Display, { "data-e2e": 'DesktopPartsOverlay_Display', children: [(0, jsx_runtime_1.jsx)(CloseButtonContainer, { "data-e2e": 'DesktopPartsOverlay_CloseButtonContainer', children: (0, jsx_runtime_1.jsx)(ui_1.CloseForGrasshopper, { id: "overlay-close-btn", onClick: onCloseFullScreen, tabIndex: 1, ref: closeRef, "data-e2e": 'DesktopPartsOverlay_CloseForGrasshopper' }) }), (0, jsx_runtime_1.jsxs)(TitleContainer, { "data-e2e": 'DesktopPartsOverlay_TitleContainer', children: [(0, jsx_runtime_1.jsx)(Title, { "data-e2e": 'DesktopPartsOverlay_Title', children: title }), subtitle] }), (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: isFullScreen, timeout: 500, classNames: "fullscreen-transition", appear: true, "data-e2e": 'DesktopPartsOverlay_CSSTransition', children: (0, jsx_runtime_1.jsxs)(Container3D, { id: "overlay-container-3d-model", "data-testid": "test-web-sdk-id", "$isFullScreen": !!isFullScreen, "$hasDescription": !!(selectedPart === null || selectedPart === void 0 ? void 0 : selectedPart.detail), "$isSidebarComponent": isSidebarComponent, ref: modelContainer, "data-e2e": 'DesktopPartsOverlay_Container3D', children: [isLoading && ((0, jsx_runtime_1.jsx)(ProgressBarContainer, { "data-e2e": 'DesktopPartsOverlay_ProgressBarContainer', children: (0, jsx_runtime_1.jsx)(ui_1.ProgressBar, { value: progress, backgroundColor: theme.grasshopper.modelBackground, "data-e2e": 'DesktopPartsOverlay_ProgressBar' }) })), isLoading && ((0, jsx_runtime_1.jsx)(ProgressIndicatorContainer, { "data-e2e": 'DesktopPartsOverlay_ProgressIndicatorContainer', children: (0, jsx_runtime_1.jsx)(ui_1.ProgressIndicator, { color: theme.grasshopper.loadingColor, "data-e2e": 'DesktopPartsOverlay_ProgressIndicator' }) })), (0, jsx_runtime_1.jsxs)(ButtonsContainer, { "data-e2e": 'DesktopPartsOverlay_ButtonsContainer', children: [(0, jsx_runtime_1.jsx)(ui_1.HideButton, { onClick: onToggleFullScreen, isSelected: !!isFullScreen, tabIndex: 2, "data-e2e": 'DesktopPartsOverlay_HideButton' }), fullScreenButtons] }), MotionControl] }) })] })] }) }));
}
exports.DesktopPartsOverlay = DesktopPartsOverlay;
const ProgressIndicatorContainer = styled_components_1.default.div `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  z-index: 12;
`;
const ProgressBarContainer = styled_components_1.default.div `
  position: absolute;
  width: calc(100% - 8px);
  left: 4px;
  top: 0px;

  z-index: 12;
`;
const Container = styled_components_1.default.div `
  color: ${({ theme }) => theme.white};
  height: calc(100vh - 50px);
  width: 100%;
  position: absolute;
  top: 50px;
  left: 0;
  display: flex;
  flex-direction: row;
  background-color: ${({ theme }) => theme.backgroundSenary};
  border-radius: 8px 8px 0 0;

  &.enter,
  &.appear {
    transform: translateY(100vh);
  }

  &.enter-active,
  &.appear-active {
    transform: translateY(0);
    transition: transform 800ms ease;
  }

  &.exit {
    transform: translateY(0);
  }

  &.exit-active {
    transform: translateY(120vh);
    transition: transform 800ms ease;
  }

  &:focus-within {
    border-color: green;
  }
`;
const Display = styled_components_1.default.div `
  flex: 5;
  flex-direction: column;
  padding: 0 2.5%;
  display: flex;
`;
const CloseButtonContainer = styled_components_1.default.div `
  position: absolute;
  top: 10px;
  right: 10px;
`;
const TitleContainer = styled_components_1.default.div `
  display: flex;
  max-width: 95%;
  flex-direction: column;
  margin: 16px 0 8px;
  gap: 8px;
`;
const Title = styled_components_1.default.h2 `
  font-size: 24px;
  margin: 0;
`;
const Subtitle = styled_components_1.default.p `
  margin: 0;
`;
const fullScreenMixin = (0, styled_components_1.css) `
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
`;
const Container3D = styled_components_1.default.div `
  position: relative;
  width: ${({ $isSidebarComponent }) => ($isSidebarComponent ? '99%' : '70%')};
  height: 80%;
  margin-bottom: 10px;
  border-radius: 4px;
  background-color: black;

  ${({ $isFullScreen }) => !$isFullScreen &&
    (0, styled_components_1.css) `
      margin: 5% auto;
    `}

  ${({ $isFullScreen }) => $isFullScreen && fullScreenMixin}

  &.fullscreen-transition-enter,
  &.fullscreen-transition-exit {
    ${fullScreenMixin}
  }

  &.fullscreen-transition-enter {
    opacity: 0;
  }

  &.fullscreen-transition-enter-active {
    opacity: 1;
    transition: opacity 1200ms ease;
  }

  &.fullscreen-transition-exit {
    opacity: 1;
  }

  &.fullscreen-transition-exit-active {
    opacity: 0;
    transition: opacity 1200ms ease;
  }

  &.grid-container,
  &.pen2d-layer,
  &.html-container,
  &.svg-container {
    display: none;
  }
`;
const ButtonsContainer = styled_components_1.default.div `
  position: absolute;
  display: flex;
  flex-direction: row;
  top: 10px;
  right: 10px;
  gap: 10px;
`;
